import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import type { MonitoringHistorySection } from '../components/MonitoringHistoryDialog';
import type { AgencyRow } from '../components/monitoringSelection';

/** Estado e ações compartilhados — Monitorar agências (Dashboard + Preferências). */
export function useAgencyMonitoringSuite() {
  const queryClient = useQueryClient();

  const [agencyMonitoringOpen, setAgencyMonitoringOpen] = useState(false);
  const [monitoringHistoryOpen, setMonitoringHistoryOpen] = useState(false);
  const [monitoringHistorySection, setMonitoringHistorySection] =
    useState<MonitoringHistorySection>('assuntos');
  const [agencyDetailLogsAgency, setAgencyDetailLogsAgency] = useState<AgencyRow | null>(null);

  const openAgencyMonitoring = useCallback(() => setAgencyMonitoringOpen(true), []);

  const closeAgencyMonitoring = useCallback(() => {
    setAgencyMonitoringOpen(false);
    void queryClient.invalidateQueries(['agencies-monitoring-history']);
    void queryClient.invalidateQueries(['agencies-monitoring']);
  }, [queryClient]);

  const openAgencyMonitoringHistory = useCallback(() => {
    setMonitoringHistorySection('agencies');
    setMonitoringHistoryOpen(true);
  }, []);

  const openMonitoringHistoryAssuntos = useCallback(() => {
    setMonitoringHistorySection('assuntos');
    setMonitoringHistoryOpen(true);
  }, []);

  const closeMonitoringHistory = useCallback(() => setMonitoringHistoryOpen(false), []);

  const openAgencyDetailLogs = useCallback((agency: AgencyRow) => {
    setAgencyDetailLogsAgency(agency);
  }, []);

  const closeAgencyDetailLogs = useCallback(() => setAgencyDetailLogsAgency(null), []);

  return {
    agencyMonitoringOpen,
    openAgencyMonitoring,
    closeAgencyMonitoring,
    monitoringHistoryOpen,
    monitoringHistorySection,
    openAgencyMonitoringHistory,
    openMonitoringHistoryAssuntos,
    closeMonitoringHistory,
    agencyDetailLogsAgency,
    openAgencyDetailLogs,
    closeAgencyDetailLogs,
  };
}

export type AgencyMonitoringSuite = ReturnType<typeof useAgencyMonitoringSuite>;
